<template>
  <div>
    <a-card style="width: 100%; text-align: center">
      <div class="table-page-search-wrapper">
        <a-form layout="inline"
                style="margin: 20px 0px 0px 20px">
          <a-row :gutter="12">
            <a-col :md="6"
                   :sm="12">
              <a-form-item label="设备名称">
                <a-input v-model="query.pointName"
                         placeholder="请输入设备名称"
                         allow-clear />
              </a-form-item>
            </a-col>
            <a-col :md="6"
                   :sm="12">
              <a-form-item label="设备序列号">
                <a-input v-model="query.monitorDeviceNo"
                         placeholder="请输入设备序列号"
                         allow-clear />
              </a-form-item>
            </a-col>
            <!-- <a-col :md="6" :sm="12">
              <a-form-item label="设备类型">
                <a-select @change="handleChange" v-model="type">
                  <a-select-option v-for="(item,index) in typelist" :key="index" :value="item">
                    {{item}}
                  </a-select-option>
                </a-select>
              </a-form-item>
            </a-col> -->
            <a-col :md="6"
                   :sm="12"
                   style="display: flex">
              <a-form-item>
                <a-button type="primary"
                          @click="queryList">查询</a-button>
              </a-form-item>
              <a-form-item style="margin-left: 12px">
                <a-button @click="resetList">重置</a-button>
              </a-form-item>
              <a-button type="primary"
                        style="margin-left: 12px"
                        @click="Handle('add', '')">新增</a-button>
              <a-button type="danger"
                        style="margin-left: 12px"
                        @click="deleteSelectRow()">删除</a-button>
            </a-col>
          </a-row>
        </a-form>
      </div>
      <a-table rowKey="id"
               :columns="columns"
               :data-source="list"
               :row-selection="{ selectedRowKeys: this.selectedRows, onChange: onSelectChange }"
               :row-class-name="(_record, index) => (index % 2 === 1 ? 'table-striped' : null)"
               :pagination="{ pageSize: 10 }"
               bordered>
        <span slot="action"
              slot-scope="text, record">
          <a @click="Handle('edit', record.id)">编辑</a>
        </span>
        <span slot="layer"
              slot-scope="text, record">
          <div :id="record.id"
               style="width: 350px"
               @click="showvidio(text)">{{ record.monitorUrl }}</div>
        </span>
      </a-table>
      <a-modal :title="this.titih"
               okText="添加"
               width="50%"
               :visible="visible"
               :confirm-loading="confirmLoading"
               @ok="handleOk"
               @cancel="handleCancel">
        <a-form :form="addOrUpdateForm"
                :label-col="{ span: 5 }"
                :wrapper-col="{ span: 12 }">
          <a-form-item label="选择泵房绑定">
            <a-select v-decorator="['pumpId', { rules: [{ required: true, message: '请选择一个泵房绑定!' }] }]"
                      placeholder="选择一个泵房绑定">
              <a-select-option v-for="(item, index) in userlist"
                               :key="index"
                               :value="item.key">
                {{ item.title }}
              </a-select-option>
            </a-select>
          </a-form-item>
          <a-form-item label="设备名称">
            <a-input v-decorator="['pointName', { rules: [{ required: true, message: '请输入名称!' }] }]" />
          </a-form-item>
          <a-form-item label="设备序列号">
            <a-input v-decorator="['monitorDeviceNo', { rules: [{ required: true, message: '请输入设备序列号!' }] }]" />
          </a-form-item>
          <a-form-item label="安装地址">
            <a-input v-decorator="['address', { rules: [{ required: true, message: '请输入安装地址!' }] }]" />
          </a-form-item>
        </a-form>
      </a-modal>
      <a-modal title="监控画面"
               width="800px"
               :visible="vidiovisible"
               @ok="handlevidio"
               @cancel="handleCancelvidio">
        <div id="vidio"></div>
      </a-modal>
    </a-card>
  </div>
</template>

<script>
import EZUIKit from 'ezuikit-js'
import mixinViewModule from '@/mixin/common'
import qs from 'qs'
export default {
  mixins: [mixinViewModule],
  data () {
    return {
      queryUrl: '/pipe-network/water_works_monitors/page',
      deleteUrl: '/pipe-network/water_works_monitors/',
      queryOneUrl: '/pipe-network/water_works_monitors/',
      addOrUpdateUrl: '/pipe-network/water_works_monitors',
      vidioUrl: '',
      visible: false,
      token: '',
      url: '',
      vidiovisible: false,
      confirmLoading: false,
      list: [],
      currentId: '',
      query: {
        monitorDeviceNo: '',
        pointName: '',
        tenantId: this.$store.state.user.info.tenantId,
      },
      querytype: '',
      userlist: [],
      titih: '添加监控设备',
      columns: [
        {
          title: '泵房名称',
          dataIndex: 'pumpName',
          align: 'center',
          width: 150,
        },
        {
          title: '视频源',
          dataIndex: 'monitorUrl',
          align: 'center',
          width: 150,
          scopedSlots: { customRender: 'layer' },
        },
        {
          title: '设备名称',
          dataIndex: 'pointName',
          align: 'center',
        },
        {
          title: '设备序列号',
          dataIndex: 'monitorDeviceNo',
          align: 'center',
        },
        {
          title: '安装地点',
          dataIndex: 'address',
          align: 'center',
        },
        {
          title: '操作',
          dataIndex: 'action',
          align: 'center',
          width: 150,
          scopedSlots: { customRender: 'action' },
        },
      ],
      addOrUpdateForm: this.$form.createForm(this, { name: 'addOrUpdate' }),
    }
  },
  created () {
    this.gettoken()
    this.getUserList()
  },
  player: null,
  mounted () { },
  methods: {
    getUserList () {
      this.$http.get('/pipe-network/twice_water_pumps/list').then(({ data }) => {

        let list = []
        data.map((item) => {
          console.log(item)
          list.push({
            title: item.pumpName + ' (' + item.pumpNo + ')',
            key: item.id,
            name: item.pumpNo,
          })
        })
        this.userlist = list
      })
    },
    handleChange (e) {
      this.type = e
      console.log(this.type)
    },
    Handle (type, id = '') {

      this.querytype = type
      if (type == 'add') {
        this.titih = '添加监控设备'
        this.addOrUpdateHandle()
        this.showModal('data')
      } else {
        this.titih = '修改监控设备'
        this.addOrUpdateHandle(id)
        this.showModal('data')
      }
      console.log(type)
    },
    showvidio (url) {
      this.url = url
      this.vidiovisible = true
      this.$nextTick(() => {
        this.vidioinit()
      })
    },
    showModal (type) {
      if (type == 'data') {
        this.visible = true
      } else {
        this.vidiovisible = true
      }
    },
    handleOk () {
      this.addOrUpdateForm.validateFields((err, values) => {
        if (!err) {
          let method
          let message
          let params
          if (this.querytype == 'add') {
            method = 'post'
            message = '新增成功'
            params = {
              monitorDeviceNo: values.monitorDeviceNo,
              monitorUrl: `ezopen://open.ys7.com/${values.monitorDeviceNo}/1.hd.live`,
              address: values.address,
              pumpId: values.pumpId,
              pointName: values.pointName,
            }
          } else {
            method = 'put'
            message = '修改成功'
            params = {
              id: this.currentId,
              monitorDeviceNo: values.monitorDeviceNo,
              monitorUrl: `ezopen://open.ys7.com/${values.monitorDeviceNo}/1.hd.live`,
              address: values.address,
              pumpId: values.pumpId,
              pointName: values.pointName,
            }
          }
          const header = {
            'Content-Type': 'application/json',
            Authorization: this.token,
          }
          this.$http({
            url: this.addOrUpdateUrl,
            method: method,
            data: params,
            header: header,
          }).then((data) => {

            this.visible = false
            this.$message.success(message)
            this.queryList()
          })
        }
      })
    },
    handleCancel (e) {
      console.log(e)
      this.visible = false
    },
    handlevidio () {
      this.vidiovisible = false
    },
    handleCancelvidio () {
      this.vidiovisible = false
    },
    gettoken () {
      let url = '/pipe-network/water_works_configurations/page'
      let data = { tenantId: this.query.tenantId, sysConf: '二次供水' }
      this.$http.get(url, data).then((resolve) => {
        console.log(JSON.stringify(resolve))
        this.token = resolve.data.list[0].token
      })
    },
    vidioinit () {
      if (!this.player) {
        this.player = new EZUIKit.EZUIKitPlayer({
          id: 'vidio', // 视频容器ID
          accessToken: this.token,
          url: this.url,
          width: 740,
          height: 500,
        })
      } else {
        this.player.stop().then(() => {
          this.player.play(this.url)
        })
        return false
      }
      this.player.play()
    },
  },
}
</script>

<style lang="less" scoped>
/deep/.table-striped {
  background-color: #fafafa;
}
#vidio {
  width: 740px;
  height: 500px;
}
</style>